import { render, staticRenderFns } from "./WsAvatar.vue?vue&type=template&id=7825cb3f&"
import script from "./WsAvatar.vue?vue&type=script&lang=js&"
export * from "./WsAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports